import React from "react";
import { ZonedDateTime } from "../../../../components/global_components/ZonedDateTime";

interface InspectionScheduledDateDisplayProps {
  scheduledDate?: string | null;
  scheduledDateTime?: string | null;
  scheduledMeridiem?: string | null;
}
export default function InspectionScheduledDateDisplay({
  scheduledDate,
  scheduledDateTime,
  scheduledMeridiem,
}: InspectionScheduledDateDisplayProps) {
  if (scheduledDateTime) {
    return <ZonedDateTime value={scheduledDateTime} formatString="EEE, MMM d, yyyy 'at' h:mm a" />;
  }
  if (scheduledDate) {
    return (
      <ZonedDateTime
        value={scheduledDate}
        timezone='UTC'
        formatString={`EEE, MMM d, yyyy '- ${scheduledMeridiem !== null ? scheduledMeridiem : "Anytime"}'`}
        timeWithRespectToAgencyTimezone={false}
      />
    );
  }
  return <>Unscheduled</>;
}
